// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"177":"home","329":"singleNew","443":"about","447":"singleItem","606":"singleSubCategory","631":"contact","876":"singleCategory"}[chunkId] + "." + {"177":"6d6bb263","329":"646a6cfc","443":"ecf309b0","447":"ecf309b0","606":"77bd9028","631":"4232c7af","876":"04e19ac5"}[chunkId] + ".css";
};